// {a: 1, b: 2} => [{name: 'a', value: 1}, {name: 'b', value: 2}]

export function makeParameters(params: Record<string, string>) {
  return Object.entries(params).map(([key, value]) => ({
    name: key,
    value,
  }));
}
